import { render, staticRenderFns } from "./Syndrome.vue?vue&type=template&id=43650072&"
import script from "./Syndrome.vue?vue&type=script&lang=ts&"
export * from "./Syndrome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43650072')) {
      api.createRecord('43650072', component.options)
    } else {
      api.reload('43650072', component.options)
    }
    module.hot.accept("./Syndrome.vue?vue&type=template&id=43650072&", function () {
      api.rerender('43650072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/Syndrome.vue"
export default component.exports